import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const QuestionIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faQuestionCircle} color={props.color || 'black'} />
  )
}
